import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { AdminStore } from './admin-types';

export const useAdminStore = create<AdminStore>()(
  devtools((set) => ({
    activeSection: 'dashboard',
    globalSearch: '',
    isLoading: false,

    setActiveSection: (section) => set({ activeSection: section }),
    setGlobalSearch: (value) => set({ globalSearch: value }),
    setIsLoading: (value) => set({ isLoading: value }),
  }))
);
